import type { SurveyNotifier } from "@survey-types/survey.core.types";
import NotificationItem from "./NotificationItem";

interface NotificationListProps {
  notifiers: SurveyNotifier[];
  onUpdateNotifier: (
    notifierId: string,
    isShortlistEnabled: boolean,
  ) => Promise<void>;
  onRemoveNotifier: (email: string) => Promise<void>;
}

const NotificationList = ({
  notifiers,
  onUpdateNotifier,
  onRemoveNotifier,
}: NotificationListProps) => {
  return (
    <div className="mb-3">
      {notifiers.map((notifier) => (
        <NotificationItem
          key={notifier.notificationId}
          notifier={notifier}
          onUpdate={onUpdateNotifier}
          onRemove={onRemoveNotifier}
        />
      ))}
    </div>
  );
};

export default NotificationList;
